import { render, staticRenderFns } from "./JoinProjectConfirmationView.vue?vue&type=template&id=857602c6"
import script from "./JoinProjectConfirmationView.vue?vue&type=script&lang=js"
export * from "./JoinProjectConfirmationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports